// Engelske tekster for Macro-planen (trinn 1–4, oktober 2026). Som
// englishExtraMessages: bare engelsk, den norske teksten står som fallback i
// koden.
export const englishMacroPlanMessages = {
  crm: {
    reports: {
      tab_questions: "Questions",
    },
    live_questions: {
      new: "New question",
      placeholder:
        "For example: open opportunities per owner, with total one-time value",
      ask: "Ask",
      busy: "Claude is writing the query …",
      help: "Claude writes one read-only query. If you save it, it runs again every time the question is opened. You only see data you otherwise have access to.",
      title: "Title",
      save: "Save",
      discard: "Discard",
      saved: "The question is saved",
      save_error: "Could not save the question",
      saved_title: "Saved questions",
      none: "No saved questions yet.",
      rerun: "Run again",
      delete: "Delete the question",
      delete_error: "Could not delete the question",
      empty: "No rows.",
      truncated: "Showing the first 500 rows.",
      row_count: "%{smart_count} row |||| %{smart_count} rows",
      show_sql: "Show the query",
    },
    settings: {
      writing_profile: {
        title: "Writing profile",
        help: "How the company writes: tone, formal or informal address, length, greeting and sign-off, words you use and words you avoid. «Draft with Claude» in the email composer follows the profile for all users. An empty profile gives short, friendly drafts.",
        label: "Profile",
      },
    },
    command: {
      ask: {
        about_button: "Ask Claude",
        about: "About %{name}",
        about_title: "Ask about %{name}",
        about_empty:
          "Claude fetches the record and what belongs to it, and lists the sources below the answer. Claude reads but changes nothing.",
      },
    },
    company_notes: {
      customer_contact: "Customer contact",
      customer_contact_help: "Counts as last contact with the customer",
    },
    summary: {
      email_in: "Email from the customer",
      email_out: "Email sent",
      sent_direct: "Sent 1:1",
      sent_campaign: "Sent campaign",
      received: "Received",
    },
    dashboard: {
      radar: {
        type: {
          email_in: "Email from the customer",
          email_out: "Email sent",
        },
      },
    },
    direct_email: {
      open: "Send email",
      title: "Email to %{name}",
      description: "Sent from Mimin to %{email}. Replies go to you.",
      send: "Send",
      sent: "The email was sent to %{email}",
      not_accepted: "Mailgun did not accept the email. It was not sent.",
    },
    detail_panel: {
      label: "Details",
      open: "Open",
      close: "Close panel",
      status: "Status",
      done: "Completed",
      due: "Due",
      assignee: "Assignee",
      customer: "Customer",
      project: "Project",
    },
    email: {
      draft: {
        button: "Draft with Claude",
        instruction: "What should the email say?",
        placeholder:
          "For example: thanks for the meeting yesterday, send the offer by Friday",
        replaces:
          "Claude builds on the existing text and replaces it. Ctrl+Z undoes.",
        help: "Claude follows the writing profile in Settings. Nothing is sent.",
        busy: "Writing …",
        submit: "Draft",
        error: "Could not create a draft. Try again.",
      },
      snippets: {
        insert: "Insert snippet",
        button: "Snippets",
        search: "Search snippets …",
        none: "No snippets yet.",
        no_match: "No matches.",
        new: "New snippet",
        edit: "Edit snippet",
        saved: "Snippet saved",
        kind: "Type",
        kind_template: "Template (fills subject and message)",
        kind_snippet: "Snippet (inserted at the cursor)",
        badge: "Snippet",
        hint: "Type ; to insert a snippet.",
        help: "Snippets are inserted at the cursor, from the Snippets button or by typing ;. All users share templates and snippets.",
      },
    },
  },
};
